module.exports = __webpack_public_path__ + "img/copper.2223f0ae.png";